module.exports = __webpack_public_path__ + "media/question5_au.fa6b8f51.mp3";